module.exports = "/dashboard/manage/locations/index-a25f09.html";